const Config={
    "name" : "TAG Heuer",
    "logo" : "t_h.png",
    "menulogo" : "t_h_menu.png",
    "logoMini" : "t_h.png",
    "copy" : "@2025 TAG Heuer",

}
export default Config



// WEBPACK FOOTER //
// ./src/utils/global.js